import graphql from "babel-plugin-relay/macro"

export const ConversationHistoryCreateCustomerMutation = graphql`
  mutation ConversationHistoryQuery_createCustomerMutation ($input: CreateCustomerInput!) {
    createCustomer(input: $input) {
      error {
        message
        code
      }
      accessToken
    }
  }
`

export const ConversationHistoryCreateChatMutation = graphql`
  mutation ConversationHistoryQuery_createChatMutation (
    $input: CreateChatInput!
  ) {
    createChat(input: $input) {
      clientMutationId
      error {
        message
        code
      }
      chat {
        _id
        messageEvent
        hidden
        from
        createdAt
        deliveredAt
        readAt
        sentAt
        threadId
        clientMutationId
      }
    }
  }
`

export const ConversationHistoryUpdateCustomerLocaleMutation = graphql`
  mutation ConversationHistoryQuery_updateCustomerLocaleMutation ($input: UpdateCustomerLocaleInput!) {
    updateCustomerLocale(input: $input) {
      customer {
        profile {
          locale
        }
      }
    }
  }
`

export const ConversationHistorySignUrlMutation = graphql`
  mutation ConversationHistoryQuery_signUrlMutation ($input: SignUrlInput!) {
   signUrl(input: $input) {
     signUrl
    }
  }
`

export const ConversationHistoryQuery = graphql`
  query ConversationHistoryQuery($last: Int, $token: ID) {
    customerViewer {
      customerProfile(token: $token) {
        locale
      }
      ...ConversationHistory_customerViewer @arguments(last: $last, token: $token)
    }
  }
`

export const ConversationHistorySubscription = graphql`
  subscription ConversationHistoryQuerySubscription(
    $token: String!
  ) {
    chat(token: $token) {
      id
      _id
      messageEvent
      hidden
      from
      createdAt
      deliveredAt
      readAt
      sentAt
      threadId
      clientMutationId
    }
  }
`